import { useWebSocketMeasurementContext } from '../providers/WebSocketMeasurementProvider';
import { IProcessedMeasurement } from 'app/types/measurement';

interface UseWebSocketMeasurementServiceReturn {
  measurements: IProcessedMeasurement[];
  status: string;
  connect: () => void;
  disconnect: () => void;
  isConnected: boolean;
}

export const useWebSocketMeasurementService = (): UseWebSocketMeasurementServiceReturn => {
  const context = useWebSocketMeasurementContext();
  
  return {
    measurements: context.measurements,
    status: context.status,
    connect: context.connect,
    disconnect: context.disconnect,
    isConnected: context.isConnected,
  };
};
